import type { BaseTranslation } from '../i18n-types';

export const welcomePage = {
    title: 'Welcome to',
    titleHighlighted: 'Random Video Chat',
    subtitle:
        '100% anonymous video sex chat where men are connected with real women. Jump head-on and have a fun and stimulating conversation right now!',
    buttonMaleLabel: 'I am Male',
    buttonFemaleLabel: 'I am Female',
    promptClickAllowToStart: 'Click <span>"Allow"</span> to start',
    promptEnableCameraTitle: 'Enable Camera and Microphone to Start Video Chat',
    promptEnableCameraSubtitle:
        'You cannot start a video chat because you have denied access to the camera and microphone. Please allow access to the camera and microphone to start.',
    noSearchResultsTitle: 'There are no available connections right now',
    noSearchResultsSubtitle:
        'Unfortunately, right now we don\'t have any available connections that match your preferences. Please try searching again later.',
    noSearchResultsButtonLabel: 'Restart Chat',
    metaTitle: `{appName:string}: Random Video Chat Roulette - Have Fun and Flirt Online`,
    metaDescription:
        `{appName:string} is a live 1-on-1 video chat roulette where men meet women in Omegle style. Find a beautiful girl worldwide and communicate with any random stranger thanks to our real-time translation in any language. Join for free!`,
} satisfies BaseTranslation;
